<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :close-on-click-modal="false"
    :title="title"
    :visible="dialogVisible"
    :before-close="beforeClose"
    append-to-body
  >
    <i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <el-form
      style="padding: 20px 20px 0 0"
      ref="form"
      :model="model"
      label-width="80px"
      :rules="rules"
      :inline="true"
    >
      <el-form-item
        label="模型"
        prop="bo_def_id"
      >
        <el-select
          filterable
          disabled
          v-model="model.bo_def_id"
        >
          <el-option
            v-for="item in boDefIdList"
            :key="item.id"
            :value="item.id"
            :label="item.description"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="表单"
        prop="form_key"
      >
        <el-select
          v-model="model.form_key"
          filterable
          @change="selectForm"
        >
          <el-option
            v-for="item in formKeyList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        class="resetBtn"
        v-if="tenantId && tenantId != -1"
      >
        <el-button @click="resetConfirm">恢复默认设置</el-button>
      </el-form-item>
    </el-form>
    <!--控制条件规则-->
    <rule-config-table
      ref="ruleConfigTable"
      :defId="model.bo_def_id"
      :scriptOrder="boDefIdList"
      :ruleConfigData="model.sub_bus_process_ctrl_rule_detail"
      @dataChange="changeTableData"
    ></rule-config-table>

    <div class="demo-drawer__footer">
      <el-button @click="beforeClose">取消</el-button>
      <el-button
        @click="submit('form')"
        type="primary"
        :loading="ruleConfigModifyLoading"
      >确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form'
import req from '@/request'
import dictUtils from '@/utils'
import { mapState } from 'vuex'
const ruleConfigTable = () => import('@/components/tenant/rule/ruleConfigTable.vue')

export default {
  name: 'RuleConfigModify',
  props: {
    selectModelId: String,
    dialogVisible: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    ruleConfigTable
  },
  data() {
    return {
      title: '业务规则',
      drawerSize: '70%',
      model: {
        bo_def_id: '',
        form_id: '',
        form_name: '',
        form_key: '',
        sub_bus_process_ctrl_rule_detail: []
      },
      ruleConfigModifyLoading: false,
      boDefIdList: [],
      formKeyList: [],
      pageBean: {
        page: 1,
        pageSize: 999,
        total: 0
      },
      tenantId: '',
      rules: {
        form_key: [{ required: true, message: '请选择表单别名', trigger: 'change' }],
        bo_def_id: [{ required: true, message: '请选择模板绑定', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.getBoDefIdList()
    if (this.selectModelId) this.getRuleConfigDetail()
    this.tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
  },
  computed: mapState({
    allDataDict: (state) => state.user.allDataDict,
    allEnumerate: (state) => state.user.allEnumerate
  }),
  watch: {
    selectModelId(newVal) {
      if (newVal) this.getRuleConfigDetail()
    },
    'model.bo_def_id'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.form_id = ''
        this.form_name = ''
        this.form_key = ''
        this.sub_bus_process_ctrl_rule_detail = []
        this.getFormKeyList(newVal)
      }
    },
    deep: true
  },
  methods: {
    getRuleConfigDetail() {
      req.get('${business}/rule/bus_process_ctrl_rule/' + this.selectModelId).then((res) => {
        if (res.data && res.data.sub_bus_process_ctrl_rule_detail) {
          res.data.sub_bus_process_ctrl_rule_detail.forEach((ruleDetail) => {
            if (ruleDetail.logic_field2 && ruleDetail.logic_field2.indexOf(',') >= 0) {
              ruleDetail.logic_field2 = ruleDetail.logic_field2.split(',')
            }
            if (ruleDetail.logic_operator !== 'EMPTY' && ruleDetail.logic_operator !== 'NOTEMPTY') {
              // dic
              if (ruleDetail.ctrl_source === 'DICT') ruleDetail['dictOptions'] = dictUtils.findDictList(ruleDetail.logic_field2_extend, this.allDataDict)
              // enum
              if (ruleDetail.ctrl_source === 'ENUM')
                ruleDetail['enumerateOptions'] = dictUtils.getAllEnumerateAttr({
                  isShowList: true,
                  typeKey: ruleDetail.logic_field2_extend,
                  allData: this.allEnumerate
                })
            }
          })
        }
        this.model = res.data
      })
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        this.ruleConfigModifyLoading = true
        if (valid) {
          let params = Object.assign({}, this.model)
          if (params.model && params.model.sub_bus_process_ctrl_rule_detail) {
            params.model.sub_bus_process_ctrl_rule_detail.forEach((ruleDetail) => {
              if (ruleDetail.logic_field2.constructor === Array) {
                ruleDetail.logic_field2 = ruleDetail.logic_field2.join(',')
              }
              if (ruleDetail.logic_operator !== 'EMPTY' && ruleDetail.logic_operator !== 'NOTEMPTY') {
                // dic
                if (ruleDetail.ctrl_source === 'DICT') delete ruleDetail.dictOptions
                // enum
                if (ruleDetail.ctrl_source === 'ENUM') delete ruleDetail.enumerateOptions
              }
            })
          }
          req
            .put('${business}/rule/bus_process_ctrl_rule/', params)
            .then(() => {
              this.ruleConfigModifyLoading = false
              this.beforeClose()
            })
            .catch(() => {
              this.ruleConfigModifyLoading = false
            })
        } else {
          this.ruleConfigModifyLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    changeTableData(tableData) {
      this.model.sub_bus_process_ctrl_rule_detail = tableData
    },
    beforeClose() {
      // this.$refs["form"].resetFields();
      this.$emit('beforeClose')
      this.model = {
        form_id: '',
        form_name: '',
        form_key: '',
        sub_bus_process_ctrl_rule_detail: []
      }
    },
    // 获取模板用途列表
    getBoDefIdList() {
      let params
      this.pageBean.total = 0
      params = {
        pageBean: '',
        sorter: []
      }
      params.pageBean = this.pageBean
      form.getBusinessObjData(params).then((resp) => {
        this.boDefIdList = resp.rows
      })
    },
    // 获取模板用途列表
    getFormKeyList(param) {
      let params = {
        boDefId: param
      }
      form.getListByBoDefId(params).then((resp) => {
        this.formKeyList = resp
      })
    },
    selectForm(selectData) {
      this.model.form_name = this.formKeyList.find((item) => item.id === selectData).name
      this.model.sub_bus_process_ctrl_rule_detail = []
    },
    /**
     * 恢复默认设置按钮点击
     */
    resetConfirm() {
      this.$confirm('恢复默认设置后，当前设置的条件将会清除，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.reset()
      })
    },
    /**
     * 恢复默认设置调接口
     */
    reset() {
      req.get('${business}/rule/bus_process_ctrl_rule/reset/' + this.model.form_key).then((res) => {
        this.model = res.data
      })
    }
  }
}
</script>

<style scoped>
.resetBtn {
  position: absolute;
  right: 10px;
}
</style>
